import isEmpty from 'lodash/isEmpty';

import { StockExchangeCodeType, SymbolAndStockExchangeCode } from '../../models/fundamental/types';
import { GWMarketDataSummaryBucket } from '../../models/gateway/types';
import { FxMDSSubscriptionService } from '../../services/subscription/FxMDSSubscription.service';
import { ISSubscriptionService } from '../../services/subscription/ISSubscription.service';
import { MDSSubscriptionService } from '../../services/subscription/MDSSubscription.service';
import { MDSTSubscriptionService } from '../../services/subscription/MDSTSubscription.service';
import { NBBOSubscriptionService } from '../../services/subscription/NBBOSubscription.service';
import { SymbolStatusSubscriptionService } from '../../services/subscription/SymbolStatusSubscription.service';
import { isFxSymbol } from '../../util/CurrencyHelpers';

// TODO: HW-1162 - cover this with unittesting
export const groupSymbolsByStockExchangeCode = (
  symbols: SymbolAndStockExchangeCode[],
): Record<StockExchangeCodeType, string[]> => symbols.reduce((accumulator: Record<StockExchangeCodeType, string[]>, {
  symbol,
  stockExchangeCode,
}) => {
  if (!accumulator[stockExchangeCode]) {
    accumulator[stockExchangeCode] = [];
  }
  accumulator[stockExchangeCode].push(symbol);
  return accumulator;
}, {} as Record<StockExchangeCodeType, string[]>);

// TODO: HW-1162 - cover this with unittesting
const chartSubscriptionFx = (
  symbolList: string[],
  buckets: GWMarketDataSummaryBucket[],
  isUnsubscription: boolean = false,
): void => {
  const symbols = symbolList.filter(item => isFxSymbol(item));
  const fxMdsService = FxMDSSubscriptionService.getInstance();

  if (buckets.includes(GWMarketDataSummaryBucket.OneDay)) {
    if (isUnsubscription) {
      fxMdsService.unsubscribeList(symbols, GWMarketDataSummaryBucket.OneDay);
    } else {
      fxMdsService.subscribeList(symbols, GWMarketDataSummaryBucket.OneDay);
    }
  }
  if (buckets.includes(GWMarketDataSummaryBucket.ThreeMonths)) {
    if (isUnsubscription) {
      fxMdsService.unsubscribeList(symbols, GWMarketDataSummaryBucket.ThreeMonths);
    } else {
      fxMdsService.subscribeList(symbols, GWMarketDataSummaryBucket.ThreeMonths);
    }
  }
};

// TODO: HW-1162 - cover this with unittesting
export const chartSubscription = (
  symbolList: SymbolAndStockExchangeCode[],
  buckets: GWMarketDataSummaryBucket[],
  isUnsubscription: boolean = false,
): void => {
  const regularSymbols: SymbolAndStockExchangeCode[] = [];
  const fxSymbols: string[] = [];

  symbolList.forEach(item => {
    if (isFxSymbol(item.symbol)) {
      fxSymbols.push(item.symbol);
    } else {
      regularSymbols.push(item);
    }
  });

  if (!isEmpty(fxSymbols)) {
    chartSubscriptionFx(fxSymbols, buckets, isUnsubscription);
  }

  if (isEmpty(regularSymbols)) {
    return;
  }

  const symbolsByExchange = groupSymbolsByStockExchangeCode(regularSymbols);
  const mdsService = MDSSubscriptionService.getInstance();

  // Make subscription requests by stockExchangeCode
  Object.entries(symbolsByExchange).forEach(([stockExchangeCode, symbolsList]) => {
    const exchangeCode = stockExchangeCode as StockExchangeCodeType;
    if (buckets.includes(GWMarketDataSummaryBucket.OneDay)) {
      if (isUnsubscription) {
        mdsService.unsubscribeList(symbolsList, GWMarketDataSummaryBucket.OneDay, exchangeCode);
      } else {
        mdsService.subscribeList(symbolsList, GWMarketDataSummaryBucket.OneDay, exchangeCode);
      }
    }
    if (buckets.includes(GWMarketDataSummaryBucket.ThreeMonths)) {
      mdsService.subscribeList(symbolsList, GWMarketDataSummaryBucket.ThreeMonths, exchangeCode);
    }
  });
};

// TODO: HW-1162 - cover this with unittesting
export const marketDataSubscribeTradeSubscription = (
  symbols: SymbolAndStockExchangeCode[],
  isUnsubscription: boolean = false,
): void => {
  const symbolsByExchange = groupSymbolsByStockExchangeCode(symbols);
  const mdsTradeSubscriptionService = MDSTSubscriptionService.getInstance();

  // Make subscription requests by stockExchangeCode
  Object.entries(symbolsByExchange).forEach(([stockExchangeCode, symbolsList]) => {
    if (isUnsubscription) {
      mdsTradeSubscriptionService.unsubscribeList(symbolsList, stockExchangeCode as StockExchangeCodeType);
    } else {
      mdsTradeSubscriptionService.subscribeList(symbolsList, stockExchangeCode as StockExchangeCodeType);
    }
  });
};

// TODO: HW-1162 - cover this with unittesting
export const instrumentSnapshotSubscription = (
  symbolList: SymbolAndStockExchangeCode[],
  isUnsubscription: boolean = false,
): void => {
  const symbols = symbolList.filter(item => !isFxSymbol(item.symbol));
  const symbolsByExchange = groupSymbolsByStockExchangeCode(symbols);
  const isSubscriptionService = ISSubscriptionService.getInstance();

  // Make subscription requests by stockExchangeCode
  Object.entries(symbolsByExchange).forEach(([stockExchangeCode, symbolsList]) => {
    if (isUnsubscription) {
      isSubscriptionService.unsubscribeList(symbolsList, stockExchangeCode as StockExchangeCodeType);
    } else {
      isSubscriptionService.subscribeList(symbolsList, stockExchangeCode as StockExchangeCodeType);
    }
  });
};

// TODO: HW-1162 - cover this with unittesting
export const nbboSubscription = (
  symbols: SymbolAndStockExchangeCode[],
  isUnsubscription: boolean = false,
): void => {
  const symbolsByExchange = groupSymbolsByStockExchangeCode(symbols);
  const nbboSubscriptionService = NBBOSubscriptionService.getInstance();

  // Make subscription requests by stockExchangeCode
  Object.entries(symbolsByExchange).forEach(([stockExchangeCode, symbolsList]) => {
    if (isUnsubscription) {
      nbboSubscriptionService.unsubscribeList(symbolsList, stockExchangeCode as StockExchangeCodeType);
    } else {
      nbboSubscriptionService.subscribeList(symbolsList, stockExchangeCode as StockExchangeCodeType);
    }
  });
};

// TODO: HW-1162 - cover this with unittesting
export const symbolStatusSubscription = (
  symbols: SymbolAndStockExchangeCode[],
  isUnsubscription: boolean = false,
): void => {
  const symbolsByExchange = groupSymbolsByStockExchangeCode(symbols);
  const symbolStatusSubscriptionService = SymbolStatusSubscriptionService.getInstance();

  // Make subscription requests by stockExchangeCode
  Object.entries(symbolsByExchange).forEach(([stockExchangeCode, symbolsList]) => {
    if (isUnsubscription) {
      symbolStatusSubscriptionService.unsubscribeList(symbolsList, stockExchangeCode as StockExchangeCodeType);
    } else {
      symbolStatusSubscriptionService.subscribeList(symbolsList, stockExchangeCode as StockExchangeCodeType);
    }
  });
};
